<template>
  <v-container fluid class="px-0 py-0">
    <CoreBomSheetTable
        title=""
        dto-list-query="BomSheetKeyParametersListQueryDTO"
        :store-name="storeTableName"
        :height="height - 260"
        :headers="headers"
        :detail-store-name="storeDetailName"
        :hide-default-footer="true"
        :hide-default-header="true"
        :show-select="true"
        :main-validator="false"
        :row-background="rowBackground"
        @embedded_action="embeddedAction($event)"
    >
      <template v-slot:item.attributes_checked="{ item }">
        <v-checkbox v-model="item.attributes_checked" dense hide-details></v-checkbox>
      </template>
    </CoreBomSheetTable>
    <v-dialog
        v-model="dialogImportTable"
    >
      <CoreBomImportTable
          @cancel="onImportClose()"
          @import="importTable($event)"
      >
      </CoreBomImportTable>
    </v-dialog>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreBomDetail from "@/components/CoreComponent/Bom/CoreBomDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import CoreBomSheetTable from "@/components/CoreComponent/BomSheet/CoreBomSheetTable";
import {useDetailStore} from "@/components/Common/CommonDetail";
import CoreBomImportTable from "@/components/CoreComponent/Bom/CoreBomImportTable";

export default {
  name: "CoreBomMainAttrTable",

  props: {
    height: {default: null},
    product_order_uid: {default: null}
  },

  components: {
    CommonTable,
    CoreBomDetail,
    BaseFieldCheck,
    CoreBomSheetTable,
    CoreBomImportTable,
  },
  
  watch: {
    product_order_uid: {
      handler(newValue, oldValue) {
        // console.log('watch BomDetail uidItem', newValue, oldValue)
        this.filterTable()
        this.storeDetail.parentUid = this.product_order_uid
        this.storeTable.uidItem = this.product_order_uid
      },
      deep: true
    },
  },

  methods: {
    embeddedAction(event) {
      // console.log('embeddedAction', event)
      if (event.actionName === 'embedded_import_bom') {
        this.dialogImportTable = true
      }
    },
    onImportClose() {
      // console.log('onImportClose', event)
      this.dialogImportTable = false
    },
    importTable(selectedItems) {
      console.log('importTable', selectedItems)
      let data = {
        selected_items: selectedItems,
      }
      this.storeTable.onAction({actionName: 'import_sheet', actionUid: null, data: data})
      this.dialogImportTable = false
    },
    rowBackground(item) {
      if (item.do_not_place === true)
        return null
      if (item.attributes_checked === true)
        return 'green lighten-4'
      if (item.attributes_checked === false)
        return 'red lighten-4'
    },
    filterTable() {
      this.storeTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'product_order__uid', value: this.product_order_uid, enable: true},
        ],
        enable: true,
      }
    },
  },


  mounted() {
    this.storeDetail = useDetailStore(this.storeDetailName)()
    this.storeAggregate = useAggregateStore()
    this.storeTable = useTableStore(this.storeTableName)()
    this.storeTable.uidItem = this.product_order_uid
    this.storeTable.options.itemsPerPage = -1
    this.storeTable.options.sortBy = ['order']
    this.storeTable.options.sortDesc = [true]
    this.storeTable.footerProps = {'items-per-page-options': [5, 20, 50, 100, 200, -1]}
    this.filterTable()
    this.storeDetail.parentUid = this.product_order_uid
    this.storeTable.uidItem = this.product_order_uid
  },

  data() {
    return {
      dialogImportTable: false,
      storeDetail: null,
      storeDetailName: uuidv4(),
      storeAggregate: null,
      storeTable: null,
      storeTableName: uuidv4(),
      headers: [
        {text: 'Task', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 10},
        {text: 'Do not place', value: 'do_not_place', sortable: false, filterable: true, divider: true, type: 'bool', align: 'center', color: 'green', width: 10},
        {
          text: 'Designator',
          value: 'designator',
          sortable: true,
          align: 'center',
          divider: true,
          width: 150,
          type: 'text'
        },
        {text: 'Checked', value: 'attributes_checked', sortable: false, divider: true, width: 70, type: 'bool'},
        {text: 'Description', value: 'descriptions_match', sortable: false, divider: true, width: 300, type: 'text'},
        {text: 'Article parameters', value: 'main_attributes_match', sortable: false, divider: true, width: 300, type: 'text'},
        {text: 'Alias', value: 'component__alias', sortable: true, align: 'left', divider: true, width: 250},
        {text: 'Article', value: 'component__article', sortable: true, align: 'left', divider: true, width: 50},
        {text: 'Saved', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 10},
      ],
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>